import { LanguageCode } from "./DataLayer.helper";

export const SITE_IDS: {
  swdc: { [key in LanguageCode]: number };
  try: { [key in LanguageCode]: number };
  support: { [key in LanguageCode]: number };
  itProDay: { [key in LanguageCode]: number };
} = {
  swdc: {
    "en-us": 1,
    de: 28,
    fr: 30,
    es: 29,
    pt: 26,
    zh: 23,
    ja: 32,
    ko: 54,
  },
  try: {
    "en-us": 6,
    de: 64,
    fr: 65,
    es: 66,
    pt: 67,
    zh: 68,
    ja: 69,
    ko: 70,
  },
  support: {
    "en-us": 47,
    de: 47,
    fr: 47,
    es: 47,
    pt: 47,
    zh: 47,
    ja: 47,
    ko: 47,
  },
  itProDay: {
    "en-us": 60,
    de: 60,
    fr: 60,
    es: 60,
    pt: 60,
    zh: 60,
    ja: 60,
    ko: 60,
  },
};
